<template>
  <div class="boxplot">
      <div :id="divId">
      </div>
  </div>
</template>

<script>
import boxplot from '../../plotly/boxplotly'

export default {
    name: "boxplot",

    props: [ 'track', 'dataKeys', 'trackData', 'useZScore', 'studySelected'],
    
    data: () => ({
        view: 'Boxplot',
    }),

    computed: {
        stratify() { 
            // console.log('st_')
            return this.$store.state.Boxplot_stratify },
        stratifyBy() { 
            // console.log('st_by')
            return this.$store.state.Boxplot_stratifyBy },
        stratifyByPrimary() { 
            // console.log('st_by')
            console.log('boxplot stratifyByPrimary', this.$store.state.Boxplot_stratifyByPrimary)
            // console.log('boxplot stratifyByPrimary)
            return this.$store.state.Boxplot_stratifyByPrimary },
        cohortSelected() { 
            return this.$store.state.Boxplot_cohortSelected },
        combinedCohort() {
            return this.$store.state.Boxplot_combinedCohort },
        divId() { 
            // console.log('usds'.split(' ').join('-'))
            return `${this.track.split(' ').join('-')}-${this.view}` },
        sampleMeta() { return this.$store.state.sampleMeta },
    },

    watch: {
        stratifyBy() { this.generateBoxplot() },
        stratify() {this.generateBoxplot()},
        track() { this.generateBoxplot() },
        trackData() { this.generateBoxplot() },
        dataKeys() { this.generateBoxplot() },
        useZScore() { this.generateBoxplot() },
        cohortSelected() { this.generateBoxplot() },
        combinedCohort() { this.generateBoxplot() },
        studySelected() { this.generateBoxplot() },
        stratifyByPrimary() { this.generateBoxplot() },
    },

    methods: {
        generateBoxplot() {
            // console.log('gen boxplot') 
            if (!this.dataKeys) { return }
            boxplot({
                divId: this.divId,
                trackData: this.trackData,
                dataKeys: this.dataKeys,
                track: this.track,
                stratify: this.stratify,
                stratifyBy: this.stratifyBy,
                useZScore: this.useZScore,
                cohortSelected: this.cohortSelected,
                combinedCohort: this.combinedCohort,
                studySelected: this.studySelected,
                stratifyByPrimary: this.stratifyByPrimary
            })
        }
    },

    mounted() { this.generateBoxplot() }
}
</script>

<style>
.boxplot {
    width: 100%;
    /* min-width: 400px; */
}
</style>